import React from 'react';

import { getCSSVariable, PressableBox, Row, Text } from '@opendoor/bricks-next';

import { GLASS_HEADER_HEIGHT, GLASS_NAV_ACTIVE_COLOR } from './constants';
import styles from './GlassHeader.module.css';

interface GlassNavLinkProps {
  name: string;
  href: string;
  hasDropdown?: boolean;
  isOpen?: boolean;
  active?: boolean;
  onPress?: () => void;
}

export const GlassNavLink: React.FC<GlassNavLinkProps> = ({
  name,
  href,
  hasDropdown,
  isOpen,
  active,
  onPress,
}) => (
  <PressableBox
    href={hasDropdown ? undefined : href}
    onPress={onPress}
    display="inline-flex"
    flexDirection="row"
    alignItems="center"
    height={GLASS_HEADER_HEIGHT}
    py="$2"
    px="$3"
    gap="$half"
    cursor="pointer"
    borderRadius="$6x"
    borderWidth={0}
    aria-label={hasDropdown ? `${name} menu` : `View ${name}`}
    aria-current={active ? 'page' : undefined}
    aria-expanded={hasDropdown ? isOpen : undefined}
    aria-haspopup={hasDropdown ? 'true' : undefined}
    analyticsName={`cosmos-glass-nav-link-${name.toLowerCase()}`}
    className={styles.navLink}
    style={
      {
        background: isOpen ? 'rgba(0, 0, 0, 0.2)' : 'transparent',
        color: isOpen ? GLASS_NAV_ACTIVE_COLOR : getCSSVariable('$contentInversePrimary', 'color'),
        '--glass-nav-hover-color': isOpen ? GLASS_NAV_ACTIVE_COLOR : 'rgba(255, 255, 255, 0.7)',
      } as React.CSSProperties
    }
    $platform-web={{
      letterSpacing: '-0.22px',
      transition: 'color 0.2s, background 0.2s',
      textDecorationLine: 'none',
    }}
  >
    <Text tag="span" typography="$labelMedium" style={{ color: 'inherit' }}>
      {name}
    </Text>
    {hasDropdown && (
      <Row
        alignItems="center"
        justifyContent="center"
        width="$6"
        height="$6"
        opacity={isOpen ? 1 : 0.6}
        hoverStyle={{ opacity: 0.9 }}
        $platform-web={{
          transition: 'transform 0.25s, opacity 0.2s',
          transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
        }}
      >
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <polyline points="6 9 12 15 18 9" />
        </svg>
      </Row>
    )}
  </PressableBox>
);
